<h2 mat-dialog-title>{{ 'ASSOCIATIONS.CAMPAIGNS.ADD_ASSOCIATION' | translate }}</h2>
<mat-dialog-content>
  <ng-container>
    <glxy-form-field prefixIcon="search" [showLabel]="false" class="search-bar">
      <input
        type="search"
        placeholder="{{ 'ASSOCIATIONS.CAMPAIGNS.MODAL.SEARCH_PLACEHOLDER' | translate }}"
        matInput
        [formControl]="searchControl"
      />
    </glxy-form-field>
    <div content>
      <glxy-form-field class="campaigns-button-group">
        <mat-radio-group>
          <div *ngFor="let campaign of campaigns$ | async">
            <div class="list-row">
              <mat-radio-button [value]="campaign.id" (change)="onItemChange(campaign)">
                {{ campaign.title }}
                <extended>
                  {{ 'ASSOCIATIONS.CAMPAIGNS.MODAL.UPDATED' | translate }}
                  {{ campaign.updated | date: 'mediumDate' }}
                </extended>
              </mat-radio-button>
            </div>
          </div>
        </mat-radio-group>
      </glxy-form-field>
      <glxy-empty-state *ngIf="(campaigns$ | async)?.length === 0 && (loading$$ | async) === false" [size]="'small'">
        <glxy-empty-state-hero>
          <mat-icon>account_circle</mat-icon>
        </glxy-empty-state-hero>
        <p>{{ 'ASSOCIATIONS.CAMPAIGNS.MODAL.NO_CAMPAIGNS' | translate }}</p>
      </glxy-empty-state>
      <div>
        <ng-container>
          <glxy-infinite-scroll-trigger
            (isVisible)="loadNext()"
            [visiblilityMargin]="0"
            [minHeight]="0"
          ></glxy-infinite-scroll-trigger>
        </ng-container>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <ng-container class="contact-dialog-footer">
    <button mat-stroked-button class="campaign-back-button" color="primary" (click)="close()">
      {{ 'ACTIONS.CANCEL' | translate }}
    </button>
    <button
      mat-flat-button
      class="campaign-next-button"
      color="primary"
      (click)="openStartCampaignDialog()"
      [disabled]="loading$$ | async"
    >
      <glxy-button-loading-indicator [isLoading]="loading$$ | async">
        {{ 'ACTIONS.NEXT' | translate }}
      </glxy-button-loading-indicator>
    </button>
  </ng-container>
</mat-dialog-actions>
